import { NgModule } from '@angular/core';
import {
  redirectLoggedInTo,
  redirectUnauthorizedTo,
} from '@angular/fire/auth-guard';
import { AngularFireAuthGuard } from '@angular/fire/compat/auth-guard';
import { RouterModule, Routes } from '@angular/router';
import { PageNotFoundComponentComponent } from 'projects/app-core/src/app/components/page-not-found-component/page-not-found-component.component';
import { PostsRoutingModule } from 'projects/app-core/src/app/posts/posts-routing.module';
import { TalksModule } from 'projects/app-core/src/app/talks/talks.module';
import { AdminAuthRoutingModule } from './admin-auth/admin-auth-routing.module';
import { AdminHomeComponent } from './pages/admin-home/admin-home.component';
import { BytesRoutingModule } from './pages/bytes/bytes-routing.module';
import { CalenderRoutingModule } from './pages/calender/calender-routing.module';
import { CampaignRoutingModule } from './pages/campaign/campaign-routing.module';
import { CirclesRoutingModule } from './pages/circles/circles-routing.module';
import { ContentRoutingModule } from './pages/content/content-routing.module';
import { EmailTemplatesRoutingModule } from './pages/email-templates/email-templates-routing.module';
import { EventsRoutingModule } from './pages/events/events-routing.module';
import { ExpertsRoutingModule } from './pages/experts/experts-routing.module';
import { LedgerRoutingModule } from './pages/ledger/ledger-routing.module';
import { ListenerRoutingModule } from './pages/listener/listener-routing.module';
import { LyfisRoutingModule } from './pages/lyfis/lyfis-routing.module';
import { MainLayoutComponent } from './pages/main-layout/main-layout.component';
import { MasterDataRoutingModule } from './pages/master-data-service/master-data-routing.module';
import { PacksRoutingModule } from './pages/packs/packs-routing.module';
import { PartnerRoutingModule } from './pages/partner/partner-routing.module';
import { PhysicalFitnessRoutingModule } from './pages/physical-fitness/physical-fitness-routing.module';
import { PromoRoutingModule } from './pages/promo/promo-routing.module';
import { ReengageAuditRoutingModule } from './pages/reengage-audit/reengage-audit-routing.module';
import { RolesPermissionRoutingModule } from './pages/roles-permission/roles-permission-routing.module';
import { RoutineRoutingModule } from './pages/routine/routine-routing.module';
import { RuleEngineRoutingModule } from './pages/rule-engine/rule-engine-routing.module';
import { GoalsRoutingModule } from './pages/goals/goals-routing.module';
import { SurveyRoutingModule } from './pages/survey/survey-routing.module';
import { TherapistRoutingModule } from './pages/therapist/therapist-routing.module';
import { TherapyPlansRoutingModule } from './pages/therapyPlans/therpay-plans/therapy-plans-routing.module';
import { UserProfileRoutingModule } from './pages/user-profile/user-profile-routing.module';

const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['login']);
const redirectLoggedIn = () => redirectLoggedInTo(['']);

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => AdminAuthRoutingModule,
    canActivate: [AngularFireAuthGuard],
    data: {
      authGuardPipe: redirectLoggedIn,
    },
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AngularFireAuthGuard],
    data: {
      authGuardPipe: redirectUnauthorizedToLogin,
    },
    children: [
      {
        path: '',
        component: AdminHomeComponent,
      },
      {
        path: 'ledger',
        loadChildren: () => LedgerRoutingModule,
      },
      {
        path: 'therapist',
        loadChildren: () => TherapistRoutingModule,
      },
      {
        path: 'partner',
        loadChildren: () => PartnerRoutingModule,
      },
      {
        path: 'content',
        loadChildren: () => ContentRoutingModule,
      },
      {
        path: 'listener',
        loadChildren: () => ListenerRoutingModule,
      },
      {
        path: 'routine',
        loadChildren: () => RoutineRoutingModule,
      },
      {
        path: 'bytes',
        loadChildren: () => BytesRoutingModule,
      },
      {
        path: 'circles',
        loadChildren: () => CirclesRoutingModule,
      },
      {
        path: 'posts',
        loadChildren: () => PostsRoutingModule,
      },
      {
        path: 'events',
        loadChildren: () => EventsRoutingModule,
      },
      {
        path: 'talks',
        loadChildren: () => TalksModule,
      },
      {
        path: 'roles-permission',
        loadChildren: () => RolesPermissionRoutingModule,
      },
      {
        path: 'user-profile',
        loadChildren: () => UserProfileRoutingModule,
      },
      {
        path: 'therapy-plans',
        loadChildren: () => TherapyPlansRoutingModule,
      },
      {
        path: 'experts',
        loadChildren: () => ExpertsRoutingModule,
      },
      {
        path: 'promo-code',
        loadChildren: () => PromoRoutingModule,
      },
      {
        path: 'survey',
        loadChildren: () => SurveyRoutingModule,
      },
      {
        path: 'packs',
        loadChildren: () => PacksRoutingModule,
      },
      {
        path: 'physical-fitness',
        loadChildren: () => PhysicalFitnessRoutingModule,
      },
      {
        path: 'calender',
        loadChildren: () => CalenderRoutingModule,
      },
      {
        path: 'email-templates',
        loadChildren: () => EmailTemplatesRoutingModule,
      },
      {
        path: 'campaigns',
        loadChildren: () => CampaignRoutingModule,
      },
      {
        path: 'master-data-config',
        loadChildren: () => MasterDataRoutingModule,
      },
      {
        path: 'rule-engine',
        loadChildren: () => RuleEngineRoutingModule,
      },
      {
        path: 'goals',
        loadChildren: () => GoalsRoutingModule,
      },
      {
        path: 'lyfis',
        loadChildren: () => LyfisRoutingModule,
      },
      {
        path: 'reengage-audit',
        loadChildren: () => ReengageAuditRoutingModule,
      },
    ],
  },
  { path: '**', pathMatch: 'full', component: PageNotFoundComponentComponent },
  // { path: 'video', component: VideostreamComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
